import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/xxx',
    name: 'xxx',
    component: () => import('@/components/EnergyConsumption/index.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/',
    name: 'mainpage',
    component: () => import('@/components/mainPage/index.vue')
  },
  {
    path: '/mainPage',
    name: 'mainPage',
    component: () => import('@/components/mainPage/index.vue')
  },
  {
    path: '/eee',
    name: 'eee',
    component: () => import('@/components/mainPage/earth.vue')
  },
  {
    path: '/bscpage1',
    name: 'bscpage1',
    component: () => import('@/components/bscpage1/index.vue')
  },
  {
    path: '/bscpage2',
    name: 'bscpage2',
    component: () => import('@/components/bscpage2/index.vue')
  },
  {
    path: '/emp1',
    name: 'emp1',
    component: () => import('@/components/emp1/index.vue')
  },
  {
    path: '/emp2',
    name: 'emp2',
    component: () => import('@/components/emp2/index.vue')
  },
  {
    path: '/MeterSVG',
    name: 'MeterSVG',
    component: () => import('@/components/MeterSVG/index.vue')
  },
  {
    path: '/MD',
    name: 'MD',
    component: () => import('@/components/MD/index.vue'),
    /*
    component: () => import('@/components/iframepage/iframe.vue'),
    meta: {
      menuParams: {
        url: 'http://172.28.130.32:88/PlantAPP/MDMonitor/Edit'
      }
    }
    */
  },
  {
    path: '/TopHeader',
    name: 'TopHeader',
    component: () => import('@/components/mainPage/topHeader.vue')
  },
  {
    path: '/InjMold',
    name: 'InjMold',
    component: () => import('@/components/InjMold/index.vue')
  },
  {
    path: '/plasticining',
    name: 'plasticining',
    component: () => import('@/components/plasticining/index.vue')
  },
  {
    path: '/AirCompressor',
    name: 'AirCompressor',
    component: () => import('@/components/AirCompressor/index.vue')
  },
  {
    path: '/Foaming',
    name: 'Foaming',
    component: () => import('@/components/Foaming/index.vue')
  },
  {
    path: '/OperEnergyDemo',
    name: 'OperEnergyDemo',
    component: () => import('@/components/OperEnergy/index.vue')
  },
  {
    path: '/OperEnergyViewer',
    name: 'OperEnergyViewer',
    component: () => import('@/components/OperEnergy/viewer.vue')
  },
  {
    path: '/OperRouteDesigner',
    name: 'OperRouteDesigner',
    component: () => import('@/components/OperEnergy/designer.vue')
  },
  {
    path: '/EnergyPerImport',
    name: 'EnergyPerImport',
    component: () => import('@/components/OperEnergy/EnergyPerImport.vue')
  },
  {
    path: '/EnergyPrice',
    name: 'EnergyPrice',
    component: () => import('@/components/OperEnergy/EnergyPrice.vue')
  },
  {
    path: '/transformer',
    name: 'transformer',
    component: () => import('@/components/transformer/index.vue')
  },
  {
    path: '/PartsEnergy',
    name: 'PartsEnergy',
    component: () => import('@/components/PartsEnergy/index.vue')
  },
  {
    path: '/EnergyCalendar',
    name: 'EnergyCalendar',
    component: () => import('@/components/calendar/index.vue')
  },
  {
    path: '/EnergyCast',
    name: 'EnergyCast',
    component: () => import('@/components/OperEnergy/EnergyCast.vue')
  },
  {
    path: '/realTimeChart',
    name: 'realTimeChart',
    component: () => import('@/components/realTimeChart/realTimeChart.vue')
  },
  {
    path: '/photovoltaic',
    name: 'photovoltaic',
    component: () => import('@/components/photovoltaic/photovoltaic.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
